import ResponsibilityPerformance from "@/assets/js/responsibilities/performances/responsibility-performance";

export default class extends ResponsibilityPerformance {
  get performed() {
    if (this.performers.count) return true;
    if (this.contributors.count >= 2) return true;
    return false;
  }
}
